<template>
  <BreadCrumb PageTitle="Nouvel Utilisateur" />
  <hashUser :userId="userId" :userUrl="userUrl" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import hashUser from "../../components/Users/hashUser.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "hashUserPage",
  components: {
    BreadCrumb,
    hashUser,
  },

  setup: () => {
    const route = useRoute();
 
    let userId = route.params.id;  // <-- get the id
    if (Array.isArray(userId)) {
      userId = userId[0] ?? "";
    }

    let userUrl = route.params.user;  // <-- get the id
    if (Array.isArray(userUrl)) {
      userUrl = userUrl[0] ?? "";
    }


    return { userId, userUrl };
  }
});
</script>